import Lang from '/@/modules/core/app/services/Lang';
import { Color } from '@/modules/core/app/enums/Color';
import { InventoryType } from '@/modules/inventory/enums/InventoryType';

export class AssetType extends InventoryType {
  static ART_JEWELRY: AssetType = {
    key: 'art_jewelry',
    get value() {
      return Lang.t('asset.art-and-jewelry');
    },
    color: Color.PUMPKIN_ORANGE,
    icon: 'diamond-ring'
  };

  static BANK_ACCOUNT: AssetType = {
    key: 'bank_account',
    get value() {
      return Lang.t('asset.bank-and-investments');
    },
    color: Color.ROYAL_BLUE,
    icon: 'saving-bank'
  };

  static BELONGING: AssetType = {
    key: 'belonging',
    get value() {
      return Lang.t('asset.personal-belongings');
    },
    color: Color.LILAC_PINK,
    icon: 'armchair'
  };

  static CASH: AssetType = {
    key: 'cash',
    get value() {
      return Lang.t('asset.cash-currencies');
    },
    color: Color.FRESH_GREEN,
    icon: 'money-bag-dollar'
  };

  static CRYPTOCURRENCY: AssetType = {
    key: 'cryptocurrency',
    get value() {
      return Lang.t('asset.crypto');
    },
    color: Color.GOLDEN_BRONZE,
    icon: 'crypto-currency-bitcoin-increase'
  };

  static FIREARM: AssetType = {
    key: 'firearm',
    get value() {
      return Lang.t('asset.firearms');
    },
    color: Color.BLACK,
    icon: 'modern-weapon-shotgun'
  };

  static FUNERAL_PRE_ARRANGEMENT: AssetType = {
    key: 'funeral_pre_arrangement',
    get value() {
      return Lang.t('asset.funeral-pre');
    },
    color: Color.COPPER_BROWN,
    icon: 'flower'
  };

  /**
   * @deprecated
   * Income type assets are deprecated with cashflows V2
   */
  static INCOME: AssetType = {
    key: 'income',
    get value() {
      return Lang.t('asset.income');
    },
    color: Color.SPICY_RED,
    icon: 'cash-payment-bag-1'
  };

  static LIFE_INSURANCE: AssetType = {
    key: 'life_insurance',
    get value() {
      return Lang.t('asset.life-insurance');
    },
    color: Color.APRICOT_ORANGE,
    icon: 'insurance'
  };

  static PENSION_PLAN: AssetType = {
    key: 'pension_plan',
    get value() {
      return Lang.t('asset.pension-plan');
    },
    color: Color.GOLD_YELLOW,
    icon: 'saving-piggy-dollars'
  };

  static PRIVATE_STOCK: AssetType = {
    key: 'private_stock',
    get value() {
      return Lang.t('asset.business-interests');
    },
    color: Color.NIGHT_SKY_BLUE,
    icon: 'currency-dollar-increase'
  };

  static REAL_ESTATE: AssetType = {
    key: 'real_estate',
    get value() {
      return Lang.t('asset.real-estate');
    },
    color: Color.PEWTER_BLUE,
    icon: 'real-estate-building-house'
  };

  static VEHICLE: AssetType = {
    key: 'vehicle',
    get value() {
      return Lang.t('asset.motor-vehicle');
    },
    color: Color.CHERRY_RED,
    icon: 'car'
  };

  static LAND: AssetType = {
    key: 'land',
    get value() {
      return Lang.t('asset.land');
    },
    color: Color.CHERRY_RED,
    icon: 'maps-pin'
  };

  static OTHER: AssetType = {
    key: 'other',
    get value() {
      return Lang.t('asset.other-type-of');
    },
    color: Color.CHERRY_RED,
    icon: 'monetization-structure'
  };

  static canAssignNamedBeneficiaries(type: string): boolean {
    return [this.BANK_ACCOUNT.key, this.LIFE_INSURANCE.key, this.PENSION_PLAN.key].includes(type);
  }

  static canAssignCoOwners(type: string): boolean {
    return [
      this.BANK_ACCOUNT.key,
      this.LAND.key,
      this.VEHICLE.key,
      this.REAL_ESTATE.key,
      this.OTHER.key
    ].includes(type);
  }

  static getAdvisorPortalInventoryTypes(): AssetType[] {
    return [
      this.BANK_ACCOUNT,
      this.LIFE_INSURANCE,
      this.PENSION_PLAN,
      this.REAL_ESTATE,
      this.ART_JEWELRY,
      this.BELONGING,
      this.CASH,
      this.PRIVATE_STOCK,
      this.LAND,
      this.VEHICLE,
      this.OTHER
    ];
  }
}
